import { Grid, Table, TableBody, TableCell, TableHead, TablePagination, TableRow, TextField } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";
import { useTranslation } from "react-i18next";
import { BillsFontIcon, ProfileIcon } from "../../components/CustomIcons";
import CustomSection from "../../components/CustomSection";
import theme from "../../theme.css";
import { formatDateToDDMMYYYYFrEpoch } from "../../utils/commons";
import { Typography, Button } from "@mui/material";
import CustomCircularProgress from "../../components/CustomCircularProgress";
import wsclients from "../../services/wsclients";
import { Field, Form } from "react-final-form";
import { DatePickerCustom, SelectBoxComponent } from "../../components/CustomFormElement";
import { statementPeriodOption } from "../../utils/util";
import validators from "../../utils/validators";
import { common } from "@mui/material/colors";
import CustomAlert from "../../components/CustomAlert";

const useStyles = makeStyles((theme) => ({
    '@global': {
        "*::-webkit-scrollbar": {
            width: theme.spacing(1),
            height: theme.spacing(0.5),
        },
        "*::-webkit-scrollbar-thumb": {
            background: theme.palette.background.onCard,
        },
        "*::-webkit-scrollbar-track": {
            background: theme.palette.background.primary
        },
    },
    main: {
        padding: theme.spacing(2),
        background: theme.palette.common.white,
    },
    content: {
        background: theme.palette.common.white,
        padding: theme.spacing(1),
        [theme.breakpoints.down('sm')]: {
            width: window.outerWidth - 25,
        },
    },
    accountBalance: {
        padding: theme.spacing(2),
        // background: theme.palette.primary.main,
        borderRadius: theme.spacing(2),
        border: '1px solid ' + theme.palette.background.card,
    },
    bg_icon: {
        paddingRight: theme.spacing(2),
    },
    form: {
        margin: theme.spacing(2, 0),
    },
    formFilter: {
        border: '1px solid ' + theme.palette.background.card,
        borderRadius: theme.spacing(2),
        padding: theme.spacing(2),
    },
    table_row: {
        cursor: 'pointer',
    },
    btnPay: {
        border: '1px solid',
        marginLeft: theme.spacing(2),
    },
    //input
    input: {
        marginTop: theme.spacing(0.5),
        color: theme.palette.common.white,
    },
    input_container: {
        padding: theme.spacing(1) + ' 0'
    },
    inputContainer: {
        border: '1px solid',
        borderColor: theme.palette.border.main,
        borderRadius: theme.spacing(2),
        height: '48px',
    },
}));

export default function InvoicesView(props) {
    const { t } = useTranslation();
    const classes = useStyles();

    const { accountFinance, currency, rows, cells, params, showFormAmount, contact } = props;
    console.log("props invoices ===", props)
    let balance = accountFinance && accountFinance.balance ? accountFinance.balance : 0;
    let overdue_amount = accountFinance && accountFinance.overdue_amount ? accountFinance.overdue_amount : 0;
    let balanceStr = '';
    if(balance && balance < 0){
        balanceStr = "-" + currency + Math.abs(balance).toFixed(2) 
    } else if(balance > 0) {
        balanceStr = currency + Math.abs(balance).toFixed(2) 
    } else {
        balanceStr = currency + "0.00";
    }
    console.log("balanceStr: ", balanceStr)

    return (
        <Grid item xs={12} className={classes.main}>
            <Grid item xs={12} container className={classes.content}>
                <CustomSection notMarginTop={true}
                    title={t('invoice_title')}
                    icon={<BillsFontIcon style={{
                        color: theme.palette.common.white,
                    }} />}
                    customClass={classes.customClass}
                >
                    <Grid item xs={12} md={6}>
                        <Grid item xs={12} className={classes.accountBalance}>
                            <Grid xs={12} item container alignItems={"center"}>
                                <Grid item alignItems='center'>
                                    <Grid className={classes.bg_icon}>
                                        <ProfileIcon style={{ color: theme.palette.primary.main }} />
                                    </Grid>
                                </Grid>
                                <Grid item alignItems='center'>
                                    <Typography variant='h6' style={{ color: theme.palette.primary.main }}>{t('account_finance')}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems='center' className={classes.balance}>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1">{t('contact_code')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1">{contact && contact.code ? contact.code : null}</Typography>
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container alignItems='center' className={classes.balance}>
                                <Grid item xs={6}>
                                    <Typography variant="subtitle1">{t('my_account_number')}</Typography>
                                </Grid>
                                <Grid item xs={6}>
                                    {accountFinance && <Typography variant="subtitle1">{accountFinance.number ? accountFinance.number : null} {accountFinance.currency_code ? "(" + accountFinance.currency_code + ")" : null}</Typography>}
                                </Grid>
                            </Grid>
                            <Grid item xs={12} container>
                                <Grid item xs={12}>
                                    <Grid item xs={12} container direction='row' className={classes.balance}>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">{t('account_balance')}</Typography>
                                            <Grid item xs={12} container alignItems='center'>
                                                <Typography variant="h6">{balanceStr}</Typography>
                                                {accountFinance && accountFinance.balance > 0 && <Button size={"small"} variant='outlined' onClick={() => props.onConfirmPay()} className={classes.btnPay}>
                                                    {t('btn_pay')}
                                                </Button>}
                                            </Grid>
                                        </Grid>
                                        <Grid item xs={6}>
                                            <Typography variant="subtitle1">{t('overdue_amount')}</Typography>
                                            <Grid item xs={12} container alignItems='center'>
                                                <Typography variant="h6">{currency}{overdue_amount.toFixed(2)}</Typography>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid item xs={12} container alignItems={"center"} className={classes.form}>
                        <Grid item xs={12} lg={6} className={classes.formFilter}>
                            <Form
                                onSubmit={props.onFilter}
                                initialValues={{ period: props.periodSeleted, transaction_type: params && params.transaction_type ? params.transaction_type : null }}
                                render={({ handleSubmit, reset, submitting, pristine, values }) => {
                                    console.log("form values: ", values);
                                    return (
                                        <Grid item xs={12} className={classes.filter}>
                                            {/* <FormAutoSave debounce={1000} save={props.onFilter} /> */}
                                            <Grid item xs={12} container alignItems='center' className={classes.period}>
                                                <Grid item xs={12} container alignItems='center'>
                                                    <Grid item xs={12} sm={2}>
                                                        <Typography variant="input_label" color='default'>{t('transaction_type')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={10} container alignItems='center'>
                                                        <Grid item xs={12}>
                                                            <Field
                                                                fullWidth
                                                                name="transaction_type"
                                                                placeholder={t('Select')}
                                                                component={SelectBoxComponent}
                                                                validate={validators.composeValidators(validators.required)}
                                                                options={props.transactionTypes}
                                                                itemValue='value'
                                                                itemDisplay='label'
                                                                showNulValue={true}
                                                                titleNullValue={t('select_type')}
                                                                // valuez={params && params.transaction_type ? params.transaction_type : null}
                                                                value={values.transaction_type}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                <Grid item xs={12} container alignItems='center'>
                                                    <Grid item xs={12} sm={2}>
                                                        <Typography variant="input_label" color='default'>{t('period_title')}</Typography>
                                                    </Grid>
                                                    <Grid item xs={12} sm={10} container alignItems='center'>
                                                        <Grid item xs={12}>
                                                            <Field
                                                                fullWidth
                                                                name="period"
                                                                placeholder={t('Select')}
                                                                component={SelectBoxComponent}
                                                                validate={validators.composeValidators(validators.required)}
                                                                options={props.listPeriods}
                                                                itemValue='value'
                                                                itemDisplay='label'
                                                                showNulValue={true}
                                                                titleNullValue={t('select_type')}
                                                                // valuez={props.periodSeleted}
                                                                value={values.periodSeleted}
                                                                onCustomChange={(event) => props.onSelectPeriod(event)}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                {props.periodSeleted == statementPeriodOption.SPECIFIC_PERIOD && <>
                                                    <Grid item xs={12} container spacing={2}>
                                                        <Grid item xs={6}>
                                                            <Field
                                                                name="from_date"
                                                                component={DatePickerCustom}
                                                                label={t('from_date')}
                                                                color='default'
                                                                isEdit={true}
                                                                valuez={props.specificPeriod.from_date}
                                                                views={["month", "year"]}
                                                                formatDate={"MM/YYYY"}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={6}>
                                                            <Field
                                                                name="to_date"
                                                                component={DatePickerCustom}
                                                                label={t('to_date')}
                                                                color='default'
                                                                isEdit={true}
                                                                valuez={props.specificPeriod.to_date}
                                                                views={["month", "year"]}
                                                                formatDate={"MM/YYYY"}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </>}
                                                <Grid item xs={12} style={{ textAlign: 'right', paddingTop: 8 }}>
                                                    <Button variant="contained" size='sm' onClick={handleSubmit}>{t('btn_submit')}</Button>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    );
                                }}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={12} className={classes.table_data}>
                        <InvoicesTable
                            t={t}
                            classes={classes}
                            cells={cells}
                            rows={rows}
                            currency={currency}
                            params={params}
                            paging={props.paging}
                            handleChangePage={props.handleChangePage}
                            onDetailInvoice={props.onDetailInvoice}
                        />
                    </Grid>
                </CustomSection>
            </Grid>
            {showFormAmount && <FormAmount
                t={t}
                classes={classes}
                open={showFormAmount}
                onPay={props.onPay}
                onChangeAmount={props.onChangeAmount}
                onClose={() => props.setShowFormAmount(false)}
            />}
        </Grid>
    )
}

function getType(type, t) {
    if (type == 'INVOICE')
        return t('invoice');
    else if (type == 'TOP_UP')
        return t('topup_title');
    else if (type == 'CREDIT_NOTE')
        return t('credit_note');
    else if (type == 'PAYMENT')
        return t('payment');
    else if (type == 'REFUND')
        return t('refund');
    else if (type == 'PAYOUT')
        return t('payout');
    else if (type == 'TRANSFER')
        return t('transfer');
    else if (type == 'MANUAL_JOURNAL')
        return t('manual_journal');
    else return null;
}

function InvoicesTable(props) {
    const { cells, rows, t, classes, params, currency } = props;
    console.log("props.paging: ", props.paging);

    return (
        <div marginTop={1}>
            <div style={{ borderRadius: 12, overflowX: 'auto' }}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            {cells && cells.length && cells.map((cell, index) => {
                                if (params.transaction_type === 'PAYMENT') {
                                    if (cell.id === 'due_date' || cell.id === 'unpaid_amount' || cell.id === 'paid_amount') {
                                        return null;
                                    } else {
                                        return (
                                            <TableCell key={index} id={cell.id} align={cell.align}>
                                                <Typography variant="body2">{cell.name}</Typography>
                                            </TableCell>
                                        );
                                    }
                                }
                                else {
                                    return (
                                        <TableCell key={index} id={cell.id} align={cell.align}>
                                            <Typography variant="body2">{cell.name}</Typography>
                                        </TableCell>
                                    );
                                }
                            })}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.showLoadMore && <TableRow>
                            <TableCell colSpan={3} align="center">
                                <CustomCircularProgress />
                            </TableCell>
                        </TableRow>}
                        {rows && rows.length > 0 && rows.map((row, index) => {
                            // if (row.type == 'CREDIT') totalCredit += row.amount
                            // else totalDebit += row.amount;
                            return (
                                <TableRow key={index} onClick={() => props.onDetailInvoice(row)} className={classes.table_row}>
                                    <TableCell>
                                        <Typography>{row.number ? row.number : ""}</Typography>
                                    </TableCell>
                                    {params.transaction_type !== 'PAYMENT' && <TableCell>
                                        <Typography>{row.invoice && row.invoice.due_date ? formatDateToDDMMYYYYFrEpoch(row.invoice.due_date) : null}</Typography>
                                    </TableCell>}
                                    <TableCell>
                                        <Typography>{row.posted_date ? formatDateToDDMMYYYYFrEpoch(row.posted_date) : null}</Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography>{row.transaction_type ? getType(row.transaction_type, t) : null}</Typography>
                                    </TableCell>
                                    <TableCell align="right">
                                        {row.type == 'CREDIT' && <Typography className={classes.credit}>{currency}{row.amount ? Number(row.amount).toFixed(2) : "0.00"}</Typography>}
                                        {row.type == 'DEBIT' && <Typography className={classes.debit}>{currency}{row.amount ? Number(row.amount).toFixed(2) : "0.00"}</Typography>}
                                    </TableCell>
                                    {params.transaction_type !== 'PAYMENT' && <TableCell align="right">
                                        {row.invoice && <Typography>{currency}{row.invoice.unpaid_amount ? Number(row.invoice.unpaid_amount).toFixed(2) : "0.00"}</Typography>}
                                    </TableCell>}
                                </TableRow>
                            );
                        })}
                    </TableBody>
                </Table>

                <TablePagination
                    rowsPerPageOptions={[10]}
                    component="div"
                    count={props.paging && props.paging.total ? props.paging.total : 0}
                    rowsPerPage={10}
                    page={props.paging && props.paging.page ? props.paging.page - 1 : 0}
                    onPageChange={props.handleChangePage}
                />
            </div>
        </div>
    );
}

function FormAmount(props) {
    const { t, classes, open, onClose, onPay, onChangeAmount, amount } = props;
    return (
        <CustomAlert
            open={open}
            isCustomMessage={true}
            hideButtonClose={true}
            message={
                <Grid item xs={12} className={classes.input_container}>
                    <Grid item xs={12} style={{ textAlign: 'left' }}>
                        <Typography variant="body2" style={{marginBottom: 8}}>{t('pay_outstanding_amount')}</Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <TextField
                            id="input-with-icon-textfield"
                            size="small"
                            type={"number"}
                            autoComplete="false"
                            className={classes.input}
                            placeholder={t('enter_amount')}
                            autoFocus={true}
                            onChange={(event) => onChangeAmount(event.target.value)}
                            fullWidth
                            InputProps={{
                                disableUnderline: true,
                                classes: { root: classes.inputContainer },
                            }}
                        />
                    </Grid>
                    <Grid item xs={12} container style={{ marginTop: 10, justifyContent: 'center' }}>
                        <Button variant="outlined" onClick={() => onClose()} style={{marginRight: 8 }}>{t('btn_cancel')}</Button>
                        <Button variant="contained" onClick={() => onPay()}>{t('btn_pay')}</Button>
                    </Grid>
                </Grid>
            }
            onClose={() => onClose()}
        />
    );
}
